import { Injectable } from '@angular/core';
import { createDeferredPromise, DeferredPromise, promiseAllArrayOrHash } from '@mode/shared/util-js';
import * as angular from 'angular';

// Service to help ease the migration to angular. It provides a $q-like interface
// Backed by either Promise or AngularJs' $q service.
@Injectable({ providedIn: 'root' })
export class QAdapterService {
  // Have a base set of functional methods available until $q is available
  // Where we're ready to remove $q (no dependency on the disgest loop),
  // these will maintain a compatible behavior. Just delete the angularjs module
  defer<T>(): DeferredPromise<T> {
    return createDeferredPromise();
  }
  resolve<T>(val: any): Promise<T> {
    return Promise.resolve(val);
  }
  reject<T>(val): Promise<T> {
    return Promise.reject(val);
  }

  all<TAll>(promises: Array<Promise<TAll>>): Promise<TAll[]>;
  all<T>(promises: { [K in keyof T]: Promise<T[K]> }): Promise<{
    [K in keyof T]: T[K];
  }>;
  all<T>(promises: T) {
    return promiseAllArrayOrHash(promises);
  }

  constructor() {}

  set$Q($q: angular.IQService) {
    this.defer = $q.defer.bind($q);
    this.reject = $q.reject.bind($q);
    this.resolve = $q.resolve.bind($q);
    this.all = $q.all.bind($q);
  }
}
